// // import React, { useState } from 'react';
// // import { Link } from 'react-router-dom';
// // import { 
// //   Home, Settings, Users, BarChart, Calendar, NotebookPen, Bed, Receipt, UserPlus, Truck, FileText 
// // } from 'lucide-react';

// // const Navbar = () => {
// //   const [isDashboardOpen, setIsDashboardOpen] = useState(false);
// //   const [isStaffOpen, setIsStaffOpen] = useState(false);
// //   const [isRoomOpen, setIsRoomOpen] = useState(false);
// //   const [isRecordOpen, setIsRecordOpen] = useState(false);
// //   const [isAmbulanceOpen, setIsAmbulanceOpen] = useState(false);

// //   return (
// //     <nav className="bg-gray-800 text-white p-4 w-64 min-h-screen">+
// //       <ul className="space-y-2">
        
// //         {/* Dashboard */}
// //         <li>
// //           <button className="flex items-center gap-2 w-full text-left p-2 hover:bg-gray-700 rounded-md"
// //             onClick={() => setIsDashboardOpen(!isDashboardOpen)}
// //           >
// //             <Home />
// //             <span>Dashboard</span>
// //           </button>
// //           {isDashboardOpen && (
// //             <ul className="ml-6 mt-2 space-y-2">
// //               <li><Link to="/home/dashboard/admin_dashboard">Admin Dashboard</Link></li>
// //               <li><Link to="/home/dashboard/doctor_dashboard">Doctor Dashboard</Link></li>
// //               <li><Link to="/home/dashboard/patient_dashboard">Patient Dashboard</Link></li>
// //             </ul>
// //           )}
// //         </li>

// //         {/* Staff */}
// //         <li>
// //           <button className="flex items-center gap-2 w-full text-left p-2 hover:bg-gray-700 rounded-md"
// //             onClick={() => setIsStaffOpen(!isStaffOpen)}
// //           >
// //             <Users />
// //             <span>Staff</span>
// //           </button>
// //           {isStaffOpen && (
// //             <ul className="ml-6 mt-2 space-y-2">
// //               <li><Link to="/home/staff/all_staff">All Staff</Link></li>
// //               <li><Link to="/home/staff/add_staff">Add Staff</Link></li>
// //               <li><Link to="/home/staff/edit_staff">Edit Staff</Link></li>
// //               <li><Link to="/home/staff/staff_profile">Staff Profile</Link></li>
// //             </ul>
// //           )}
// //         </li>

// //         {/* Reports */}
// //         <li><Link to="/home/reports" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><BarChart /> Reports</Link></li>

// //         {/* Settings */}
// //         <li><Link to="/home/settings" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><Settings /> Settings</Link></li>

// //         {/* Calendar */}
// //         <li><Link to="/home/calendar" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><Calendar /> Calendar</Link></li>

// //         {/* Register */}
// //         <li><Link to="/home/register" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><NotebookPen /> Register</Link></li>

// //         {/* Room Allotment */}
// //         <li>
// //           <button className="flex items-center gap-2 w-full text-left p-2 hover:bg-gray-700 rounded-md"
// //             onClick={() => setIsRoomOpen(!isRoomOpen)}
// //           >
// //             <Bed />
// //             <span>Room Allotment</span>
// //           </button>
// //           {isRoomOpen && (
// //             <ul className="ml-6 mt-2 space-y-2">
// //               <li><Link to="/home/room_allotment/alloted_rooms">Allotted Rooms</Link></li>
// //               <li><Link to="/home/room_allotment/new_allotment">New Allotment</Link></li>
// //               <li><Link to="/home/room_allotment/edit_allotment">Edit Allocation</Link></li>
// //               <li><Link to="/home/room_allotment/rooms_by_department">Rooms by Department</Link></li>
// //               <li><Link to="/home/room_allotment/add_room">Add Room</Link></li>
// //             </ul>
// //           )}
// //         </li>

// //         {/* Records */}
// //         <li>
// //           <button className="flex items-center gap-2 w-full text-left p-2 hover:bg-gray-700 rounded-md"
// //             onClick={() => setIsRecordOpen(!isRecordOpen)}
// //           >
// //             <Receipt />
// //             <span>Records</span>
// //           </button>
// //           {isRecordOpen && (
// //             <ul className="ml-6 mt-2 space-y-2">
// //               <li><Link to="/home/records/birth_records">Birth Records</Link></li>
// //               <li><Link to="/home/records/death_records">Death Records</Link></li>
// //             </ul>
// //           )}
// //         </li>

// //         {/* Ambulance */}
// //         <li>
// //           <button className="flex items-center gap-2 w-full text-left p-2 hover:bg-gray-700 rounded-md"
// //             onClick={() => setIsAmbulanceOpen(!isAmbulanceOpen)}
// //           >
// //             <Truck />
// //             <span>Ambulance</span>
// //           </button>
// //           {isAmbulanceOpen && (
// //             <ul className="ml-6 mt-2 space-y-2">
// //               <li><Link to="/home/ambulance/ambulance_list">Ambulance List</Link></li>
// //               <li><Link to="/home/ambulance/ambulance_call_list">Ambulance Calls</Link></li>
// //             </ul>
// //           )}
// //         </li>

// //         {/* Pharmacy */}
// //         <li><Link to="/home/pharmacy" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><FileText /> Pharmacy</Link></li>

// //         {/* Blood Bank */}
// //         <li><Link to="/home/blood_bank" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><FileText /> Blood Bank</Link></li>

// //         {/* Accounts */}
// //         <li><Link to="/home/accounts" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><FileText /> Accounts</Link></li>

// //         {/* Departments */}
// //         <li><Link to="/home/departments" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><FileText /> Departments</Link></li>

// //         {/* Inventory */}
// //         <li><Link to="/home/inventory" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><FileText /> Inventory</Link></li>

// //         {/* Human Resources */}
// //         <li><Link to="/home/human_resources" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><FileText /> Human Resources</Link></li>

// //         {/* Insurance */}
// //         <li><Link to="/home/insurance" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><FileText /> Insurance</Link></li>

// //       </ul>
// //     </nav>
// //   );
// // };

// // export default Navbar;

// import React, { useState } from 'react';
// import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
// import { Link } from 'react-router-dom';
// import {
//   Home, Settings, Users, BarChart, Calendar, NotebookPen, Bed,
//   Receipt, Truck, FileText
// } from 'lucide-react';


// const AppSidebar = () => {
//   const [collapsed, setCollapsed] = useState(false);
//     const [activeTab, setActiveTab] = useState(''); 

//   const toggleSidebar = () => {
//     setCollapsed(!collapsed);
//   };

//     const getStyle = (tabName) => ({
//     backgroundColor: activeTab === tabName ? '#21766f' : 'transparent',
//     borderRadius: activeTab === tabName ? '50px' : '0px',
//     color: activeTab === tabName ? '#fff' : 'inherit',
//     margin: activeTab === tabName ? '5px' : '0px',
//   });


//   return (
//     <div style={{ display: 'flex', height: '100vh' }}>
//       <Sidebar collapsed={collapsed}>
//         <Menu>
//           <MenuItem  onClick={toggleSidebar} >{collapsed ? '' : ''}  ☰</MenuItem>
//          <MenuItem component={<Link to="/receptionist/home" />}  style={getStyle('receptionist_dashboard')}
//             onClick={() => setActiveTab('receptionist_dashboard')}>Receptionist Dashboard</MenuItem>
//          <MenuItem component={<Link to="/receptionist/home/patients/new" />} icon={<FileText size={16} />}  style={getStyle('add_patient')}
//             onClick={() => setActiveTab('add_patient')}>Add Patient</MenuItem>
//          <MenuItem component={<Link to="/receptionist/home/appointments/new" />} icon={<FileText size={16} />} style={getStyle('book_appointment')}
//             onClick={() => setActiveTab('book_appointment')}>Book Appointment</MenuItem>
//          <MenuItem component={<Link to="/receptionist/home/appointments" />} icon={<FileText size={16} />}  style={getStyle('appointments')}
//             onClick={() => setActiveTab('appointments')}>Appointments</MenuItem>
//          <MenuItem component={<Link to="/receptionist/home/billing/list" />} icon={<FileText size={16} />} style={getStyle('billing')}
//             onClick={() => setActiveTab('billing')}>Billing</MenuItem>

//            <MenuItem component={<Link to="/receptionist/home/pharmacy-billing" />} icon={<FileText size={16} />} style={getStyle('pharmacy_billing')}
//             onClick={() => setActiveTab('pharmacy_billing')}>Pharmacy Billing</MenuItem>
         
          
                

//         </Menu>
//       </Sidebar>
//     </div>
//   );
// };

// export default AppSidebar;







import React, { useState } from 'react';
import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import { Link, useLocation } from 'react-router-dom';
import 'boxicons/css/boxicons.min.css'; // Boxicons CSS import

const AppSidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [activeTab, setActiveTab] = useState('');
   const location = useLocation();

   const isActive = (path) => location.pathname === path;

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const getStyle = (tabName) => ({
    backgroundColor: activeTab === tabName ? '#21766f' : 'transparent',
    borderRadius: activeTab === tabName ? '50px' : '0px',
    color: activeTab === tabName ? '#fff' : 'inherit',
    margin: activeTab === tabName ? '5px' : '0px',
  });

  return (
    <div style={{ display: 'flex', height: '100vh',position:"sticky" }}>
      <Sidebar collapsed={collapsed}>
        <Menu>
          <MenuItem onClick={toggleSidebar}>{collapsed ? '' : ''} ☰</MenuItem>

          <MenuItem
            component={<Link to="/receptionist/home" />}
            style={getStyle('receptionist_dashboard')}
            onClick={() => setActiveTab('receptionist_dashboard')}
            icon={<i className="bx bxs-dashboard sidebar-icon" />}
            className={`sidebar-item ${isActive("/receptionist/home") ? 'active' : ''}`}
          >
            Receptionist Dashboard
          </MenuItem>

          <MenuItem
            component={<Link to="/receptionist/home/patients/new" />}
            style={getStyle('add_patient')}
            onClick={() => setActiveTab('add_patient')}
            icon={<i className="bx bxs-user-plus sidebar-icon" />}
            className={`sidebar-item ${isActive("/receptionist/home/patients/new") ? 'active' : ''}`}
          >
            Add Patient
          </MenuItem>

          <MenuItem
            component={<Link to="/receptionist/home/appointments/new" />}
            style={getStyle('book_appointment')}
            onClick={() => setActiveTab('book_appointment')}
            icon={<i className="bx bxs-calendar-plus sidebar-icon" />}
             className={`sidebar-item ${isActive("/receptionist/home/appointments/new") ? 'active' : ''}`}
          >
            Book Appointment
          </MenuItem>

          <MenuItem
            component={<Link to="/receptionist/home/appointments" />}
            style={getStyle('appointments')}
            onClick={() => setActiveTab('appointments')}
            icon={<i className="bx bxs-calendar sidebar-icon" />}
            className={`sidebar-item ${isActive("/receptionist/home/appointments") ? 'active' : ''}`}
          >
            Appointments
          </MenuItem>

          <MenuItem
            component={<Link to="/receptionist/home/billing/list" />}
            style={getStyle('billing')}
            onClick={() => setActiveTab('billing')}
            icon={<i className="bx bxs-receipt sidebar-icon" />}
            className={`sidebar-item ${isActive("/receptionist/home/billing/list")? 'active' : ''}`}
          >
            Billing
          </MenuItem>

          <MenuItem
            component={<Link to="/receptionist/home/pharmacy-billing" />}
            style={getStyle('pharmacy_billing')}
            onClick={() => setActiveTab('pharmacy_billing')}
            icon={<i className="bx bxs-capsule sidebar-icon" />}
            className={`sidebar-item ${isActive("/receptionist/home/pharmacy-billing")? 'active' : ''}`}
          >
            Pharmacy Billing
          </MenuItem>
        </Menu>
      </Sidebar>
    </div>
  );
};

export default AppSidebar;

